{
  "colorSwatchPicker": "تغييرات الألوان",
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "حدد عنصرًا",
  "tableResizer": "أداة تغيير الحجم"
}
